import React from 'react';
import AbstractMenu from './AbstractMenu';
import {SubMenuProps} from '../../../../../@types/components/Menu';
import localeConnector from '../../../../../helpers/localeConnector';
import classnames from '../../../../../helpers/classnames';

export class SubMenu extends AbstractMenu<SubMenuProps> {
    protected subMenuComponent: React.ReactNode = React.Fragment;

    protected getULListProps(): React.HTMLProps<HTMLUListElement & React.AriaAttributes> {
        return {
            ...super.getULListProps(),
            'aria-expanded': this.props.open,
        };
    }

    protected getULListClassName(): string | undefined {
        return classnames(this.props.menuClassName, {
            'd-none': !this.props.open && this.props.openAllSubMenus !== true,
        });
    }

    protected isOpenItem(): boolean {
        return false;
    }

    protected toggleItem() {
        return;
    }

    protected renderSectionItem(): React.ReactNode {
        return null;
    }

    protected renderSubmenuItem(): React.ReactNode {
        return null;
    }
}

export default localeConnector(SubMenu);
